import type { ReactNode } from 'react'
import styled from 'styled-components'

import { Footer } from './Footer'
import { Spacer } from '@/components/elements/Spacer'

type Props = {
  children: ReactNode
}

export const Layout = ({ children }: Props) => {
  return (
    <Container>
      {children}
      <Spacer h={{ sp: 70, pc: 140 }} />
      <Footer />
    </Container>
  )
}

const Container = styled.div`
  width: 1040px;
  margin: 94px auto 130px;

  @media screen and (max-width: 1047px) {
    margin: 40px auto 120px;
    width: 100%;
    padding: 0 20px;
  }
`
